import { useCallback, useEffect, useState } from "react";
import { listBusinessCases, type BusinessCaseOverviewItem } from "../api/businessCase";

const CATEGORY_LABELS: Record<string, string> = {
    "brand-partnership": "Brand Partnership",
    "campaign-of-the-year": "Campaign of the Year",
    "service-provider": "Service Provider",
};

function AdminBusinessCases({ token }: { token: string }) {
    const [items, setItems] = useState<BusinessCaseOverviewItem[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            setItems(await listBusinessCases(token));
        } catch (err) {
            setError(err instanceof Error ? err.message : "Konnte Business Cases nicht laden.");
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => { load(); }, [load]);

    return (
        <section className="admin-card">
            <div className="admin-status-head">
                <h2 className="admin-card-title">Business Cases</h2>
                <button className="admin-btn-secondary" onClick={load} disabled={loading}>
                    {loading ? "Lädt…" : "Aktualisieren"}
                </button>
            </div>

            {error && <p className="admin-error">{error}</p>}

            {items.length > 0 ? (
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Firma</th>
                            <th>Kategorie</th>
                            <th>Titel</th>
                            <th>Eingereicht</th>
                            <th>Kontakt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((it) => (
                            <tr key={it.id}>
                                <td>{it.companyName}</td>
                                <td>{CATEGORY_LABELS[it.category] ?? it.category}</td>
                                <td>{it.caseTitle}</td>
                                <td>{new Date(it.createdAt).toLocaleString()}</td>
                                <td>
                                    {it.contactName}<br />
                                    {it.contactEmail}<br />
                                    {it.contactPhone}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                !loading && <p className="admin-note">Noch keine Business Cases eingereicht.</p>
            )}
        </section>
    );
}

export default AdminBusinessCases;
